import React from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import DocumentaryList from "./DocumentaryList";
import File from "Page/File";
import BasicTabs from "components/BasicTabs";
import { ALL_PERMISSION } from "constants/permission";

export default function ListCustomer() {
  const { t: translation } = useTranslation();
  const listTab = [{
    key: "documentarylist",
    label :translation("documentary.tabs.documentarylist"),
    component: <DocumentaryList />,
  },
  {
    key: "file",
    label :translation("documentary.tabs.file"),
    permission: ALL_PERMISSION.MANAGE_DOCMENTARY.permissionTab.MANAGE_FILE.value,
    component: <File />,
  }
]
  return (
    <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGE_DOCMENTARY.permissionTab} />
  );
}